import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Dropdown as AntDropdown, Button } from "antd";
import React from "react";

export type DropdownItem = {
  label: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: "default" | "danger" | "emotion";
};

type Props = {
  items: DropdownItem[];
  triggerLabel?: React.ReactNode;
} & Omit<React.ComponentProps<typeof AntDropdown>, "menu">;

const PersistentDropdown: React.FC<Props> = ({
  items,
  triggerLabel,
  ...props
}) => {
  const menuItems: MenuProps["items"] = items.map((item, index) => ({
    key: String(index),
    disabled: item.disabled,
    label: (
      <div
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => {
          e.stopPropagation();
          item.onClick?.();
        }}
        style={{
          cursor: item.disabled ? "not-allowed" : "pointer",
          color: item.type === "danger" ? "red" : undefined,
          fontWeight: item.type === "emotion" ? "bold" : undefined,
        }}
      >
        {item.label}
      </div>
    ),
  }));

  return (
    <AntDropdown
      menu={{ items: menuItems }}
      trigger={["click"]}
      placement="bottomRight"
      {...props}
    >
      <Button>
        {triggerLabel ?? "Dropdown"}
        <DownOutlined />
      </Button>
    </AntDropdown>
  );
};

export default PersistentDropdown;
